import type {IProduct} from '../types/galleryTypes';
import {getProductVariantBySelectionIds} from '@wix/wixstores-client-core/dist/es/src/productVariantCalculator/ProductVariantCalculator';

export interface ProductsPriceRangeServiceMap {
  [productId: string]: string;
}

export class ProductsPriceRangeService {
  private products: IProduct[] = [];
  private userInput: {
    [productId: string]: number[];
  } = {};

  public addProducts(products: IProduct[]): void {
    this.products = products;
  }

  public getProductPriceRangeMapOld(): ProductsPriceRangeServiceMap {
    return this.products.reduce<ProductsPriceRangeServiceMap>((map, product) => {
      const input = this.userInput[product.id];
      if ((!input || input.length === 0) && product.priceRange) {
        map[product.id] = product.itemDiscount?.priceAfterDiscount || product.priceRange.fromPriceFormatted;
      }
      return map;
    }, {});
  }

  public getProductPriceRangeMap(): ProductsPriceRangeServiceMap {
    return this.products.reduce<ProductsPriceRangeServiceMap>((map, product) => {
      const variantSelectionIds = this.userInput[product.id] ?? [];
      const selectedVariant = getProductVariantBySelectionIds({
        product,
        variantSelectionIds,
      });
      if (!selectedVariant && product.priceRange) {
        map[product.id] = product.itemDiscount?.priceAfterDiscount || product.priceRange.fromPriceFormatted;
      }
      return map;
    }, {});
  }

  public handleUserInput(productId: string, selectionIds: number[]): void {
    this.userInput[productId] = selectionIds;
  }

  public clearSelectionsForProduct(productId: string): void {
    delete this.userInput?.[productId];
  }
}
